import React, { Component } from "react";
import { Link } from "react-router-dom";
import { cloneDeep, isEmpty } from "lodash";
import {
  Row,
  Col,
  Card,
  Icon,
  DatePicker,
  Input,
  Table,
  Button,
  Menu,
  Select,
  Popconfirm,
  message,
  Tooltip,
} from "antd";
import moment from "moment";
import F from "../../Functions";
import axios from "axios";
import Pagination from "../../components/pagination";
import Filters from "./filters";
import ActionMenu from "../LandingPage/menu";
import { Translate, Translator } from "react-translated";
import SetupAppointment from "../LandingPage/parts/setup-appointment-modal";
import TransferBfile from "./parts/transfer-bfile-modal";
import ChangeCreator from "./parts/change-creator-modal";
import "./callpage.css";
import {
  API_DATE_FORMAT,
  debounceQuery,
  get_label_from_value,
  CARD_HISTORY_TYPE,
  AGENCY_MANAGER,
  EA,
  TYPE_OF_CALL,
  PROSPECT,
} from "../../utils/Constants";
import Cookies from "js-cookie";
import { GET_ALL_DELETED_BFILES, OLD_BFILE_API_URL } from "../../utils/Api_enums";
import CustomAgGridTable from '../../Common-Table/CustomAgGridTable';
import '../../Common-Table/CustomAgGridTable.css';
import CustomHeader from '../../CommonHeader/CustomHeader';

const InputGroup = Input.Group;
const { RangePicker } = DatePicker;
const Option = Select.Option;
const today = new Date();

class CallPage extends Component {
  state = {
    loading: true,
    user_t: localStorage.getItem('user_t'),
    callpage: "mtd",
    title: "B Files",
    show_history_button: false,
    path: this.props.location.pathname,
    start_date: new Date(today.getFullYear(), today.getMonth(), 1),
    end_date: new Date(today.getFullYear(), today.getMonth() + 1, 1),
    bfiles: [],
    user: this.props.auth.user,
    selectedRowKeys: [],
    selectedBfiles: [],
    selectedPageAndBFileIDs: {}, // { page : [1000,3000] , page : [2000,5000] } => { 1 : [1000,3000] , 2 : [2000,5000] }
    windowHeight: window.innerHeight - 350,
    page: 1,
    total_pages: 0,
    filters: "",
    endpoint: OLD_BFILE_API_URL,
    columns: null,
    order_by: null,
    date_range: true,
    search: "",
    agencies: [],
    agency: "",
    setup_appointment_modal: false,
    bfile: null,
    transfer_bfile_modal: false,
    change_creator_modal: false,
    orderBy: null,
    orderBySort: null,
    bad_phone: [],
  };

  call_rs_agencies = () => {
    axios.get("/api/rs_agencies").then((res) => {
      this.setState({ agencies: res.data });
    });
  };
  call_vo_agancies = () => {
    axios.get("/api/vo_agencies").then((res) => {
      this.setState({ agencies: res.data });
    });
  };

  componentDidMount = () => {
    // new add for default -> monthly

    // start date
    let start_date = moment(
      new Date(today.getFullYear(), today.getMonth(), 1)
    ).format(API_DATE_FORMAT);

    // end date
    let end_date = moment(
      new Date(today.getFullYear(), today.getMonth() + 1, 1)
    ).format(API_DATE_FORMAT);

    // check filters from previous screen -> dashboard
    // if (
    //   "user_period" in window.localStorage &&
    //   window.localStorage.user_start_date !== "null" &&
    //   window.localStorage.user_end_date !== "null"
    // ) {
    //   start_date = window.localStorage.user_start_date;
    //   end_date = window.localStorage.user_end_date;
    // }

    const { user } = this.state;
    let search = "";
    let agency = "";
    F.log("user==>>", JSON.stringify(user));
    F.log("user_type==>>", user.user_type);

    if (typeof this.props.match.params.search !== "undefined") {
      search = this.props.match.params.search;
    }

    if (user.user_type === "EFS") {
      axios.get("/api/my_agencies").then((res) => {
        this.setState({ agencies: res.data });
      });
      if (
        "efs_agency_id" in window.localStorage &&
        window.localStorage.efs_agency_id !== ""
      ) {
        agency = parseInt(window.localStorage.efs_agency_id);
      }
    }

    if (user.user_type === "REVIEWSCHEDULER") {
      if (
        "rs_agency_id" in window.localStorage &&
        window.localStorage.rs_agency_id !== ""
      ) {
        agency = parseInt(window.localStorage.rs_agency_id);
      }
      this.call_rs_agencies();
    }

    if (user.user_type === "VONBOARDER") {
      if (
        "rs_agency_id" in window.localStorage &&
        window.localStorage.rs_agency_id !== ""
      ) {
        agency = parseInt(window.localStorage.rs_agency_id);
      }
      this.call_vo_agancies();
    }

    if (user.user_type === "EA") {
      axios.get("/api/users/" + user.id).then((res) => {
        if (
          res.data.user_agency_assoc &&
          res.data.user_agency_assoc.length > 0
        ) {
          agency = res.data.user_agency_assoc[0].agency_id || null;
        }
        this.setState({ agency });
      });
    }





    ////////////////////////////////////////////

    if (
      typeof this.props.match.params.from !== "undefined" &&
      typeof this.props.match.params.to !== "undefined"
    ) {
      start_date = moment(decodeURIComponent(this.props.match.params.from));
      end_date = moment(decodeURIComponent(this.props.match.params.to));
      // this.setState({ start_date, end_date });
    }

    // new added for handling custom date range
    if (
      this.props.location.state != null &&
      this.props.location.state.from != null &&
      this.props.location.state.to != null
    ) {
      // alert(2);
      // start_date = moment(this.props.location.state.from);
      // end_date = moment(this.props.location.state.to);
      start_date = this.props.location.state.from;
      end_date = this.props.location.state.to;
      // this.setState({ start_date, end_date });
    }

    let show_history_button = false;
    if (this.props.location && this.props.location.search) {
      const queryParams = new URLSearchParams(this.props.location.search);

      const search = decodeURIComponent(queryParams.get("selected_card_type"));

      switch (search) {
        case CARD_HISTORY_TYPE.UPLOAD:
        case CARD_HISTORY_TYPE.SCHEDULE_ACTIVITY:
        case CARD_HISTORY_TYPE.NOT_INTERESTED:
        case CARD_HISTORY_TYPE.COMPLETED:
          show_history_button = true;
          break;
        default:
          show_history_button = false;
          break;
      }
    }

    ///////////////////////////////////////////

    this.setState(
      {
        search,
        agency,
        start_date,
        end_date,
        show_history_button: show_history_button,
      },
      () => {
        if (this.isAllBFiles()) {
          this.all();
        } else if (this.getGlobalDates()) {
          this.setGlobalDates();
        } else {
          this.updateFilters();
        }
      }
    );
  };

  componentDidUpdate = (prevProps, prevState) => {
    if (prevProps.location.state !== this.props.location.state) {
      this.refreshInfo();
    }

    if (this.props.location.pathname !== this.state.path) {
      this.setState({ path: this.props.location.pathname }, () => {
        this.updateFilters();
      });
    }
    if (
      typeof this.props.match.params.search !== "undefined" &&
      this.props.match.params.search !== this.state.search
    ) {
      this.setState({ search: this.props.match.params.search }, () => {
        this.updateFilters();
      });
    }
    // new add for agency id => EA
    // if (prevState.agency !== this.state.agency) {
    //   this.updateFilters();
    // }
  };

  isAllBFiles = () => {
    return (
      this.props.history.location.search !== "" &&
      this.props.history.location.search.indexOf("all_bfiles") >= 0
    );
  };

  getGlobalDates = () => {
    return (
      this.props.history.location.search !== "" &&
      this.props.history.location.search.indexOf("dates") >= 0
    );
  };


  updateFilters = () => {
    const { user, user_t } = this.state;
    let { start_date, end_date, agencies } = this.state;
    const today = moment(new Date()).format(API_DATE_FORMAT);
    let title = "B Files";
    let filters = "";
    let callpage = "bfiles";
    // let endpoint = "b_file";
    let endpoint = OLD_BFILE_API_URL;
    let columns = null;
    let order_by = null;
    let date_range = true;

    const queryParams = new URLSearchParams(this.props.location.search);
    const call_type = decodeURIComponent(queryParams.get("call_type")) || null;

    // if (
    //   typeof this.props.match.params.from !== "undefined" &&
    //   typeof this.props.match.params.to !== "undefined"
    // ) {
    //   start_date = moment(decodeURIComponent(this.props.match.params.from));
    //   end_date = moment(decodeURIComponent(this.props.match.params.to));
    //   this.setState({ start_date, end_date });
    // }

    // // new added for handling custom date range
    // if (
    //   this.props.location.state != null &&
    //   this.props.location.state.from != null &&
    //   this.props.location.state.to != null
    // ) {
    //   // alert(2);
    //   // start_date = moment(this.props.location.state.from);
    //   // end_date = moment(this.props.location.state.to);
    //   start_date = this.props.location.state.from;
    //   end_date = this.props.location.state.to;
    //   this.setState({ start_date, end_date });
    // }
    if (typeof this.props.match.params.filter !== "undefined") {
      callpage = this.props.match.params.filter;
      if (typeof Filters[this.props.match.params.filter] !== "undefined") {
        const f = Filters[this.props.match.params.filter];
        title = f.title !== "" ? f.title : "B Files";
        if (typeof f.filters !== "undefined") {
          filters = f.filters;
        }
        if (typeof f.endpoint !== "undefined") {
          endpoint = f.endpoint;
        }
        if (typeof f.columns !== "undefined") {
          columns = f.columns;
        }
        if (typeof f.order_by !== "undefined") {
          order_by = f.order_by;
        }
        if (typeof f.date_range !== "undefined") {
          date_range = f.date_range;
        }
      }
    } else {
      date_range = false;
    }

    F.log("agency_id==>> ", this.state.agency);
    F.log("date_range==>> ", date_range);
    if (this.state.agency && this.state.agency !== "") {
      if (filters !== "") filters = filters + ",";
      filters =
        filters +
        '{"name":"agency_id","op":"==","val":"' +
        this.state.agency +
        '"}';
    }

    // if (
    //   this.props.history.location &&
    //   this.props.history.location.state &&
    //   this.props.history.location.state.type_of_call &&
    //   this.props.history.location.state.type_of_call !== "Review"
    // ) {
    //   if (filters !== "") filters = filters + ",";
    //   filters =
    //     filters +
    //     '{"name":"type_of_call","op":"==","val":"' +
    //     this.props.history.location.state.type_of_call +
    //     '"}';
    // }

    if (call_type && call_type !== "null" && call_type !== null && call_type !== "" && callpage !== "bad-phone-numbers") {

      if (filters !== "") filters = filters + ",";
      if (call_type !== PROSPECT) {
        filters =
          filters +
          '{"or":[{"name":"type_of_call","op":"is_null"},{"name":"type_of_call","op":"==","val":"' +
          call_type +
          '"}]}';
      }
      else {
        filters =
          filters +
          '{"name":"type_of_call","op":"==","val":"' +
          call_type +
          '"}';
      }
    }
    // `{"or": [{"name": "type_of_call","op": "is_null"},{"name": "type_of_call","op": "==","val": "${call_type}"}]}`

    if (user_t && user_t !== null && user_t !== "" && callpage !== "bad-phone-numbers") {

      if (filters !== "") filters = filters + ",";
      filters =
        filters +
        '{"name":"user_id","op":"==","val":"' +
        user_t +
        '"}';
    }

    const searchPurify = F.removeSpecialCharactersFromString(this.state.search);

    if (searchPurify !== "") {
      const queries = [];
      queries.push({
        name: "first_name",
        op: "like",
        val: encodeURIComponent("%" + searchPurify + "%"),
      });
      queries.push({
        name: "last_name",
        op: "like",
        val: encodeURIComponent("%" + searchPurify + "%"),
      });
      queries.push({
        name: "spouse_first_name",
        op: "like",
        val: encodeURIComponent("%" + searchPurify + "%"),
      });
      queries.push({
        name: "spouse_last_name",
        op: "like",
        val: encodeURIComponent("%" + searchPurify + "%"),
      });
      queries.push({
        name: "email",
        op: "like",
        val: encodeURIComponent("%" + searchPurify + "%"),
      });
      queries.push({
        name: "phone",
        op: "like",
        val: encodeURIComponent("%" + searchPurify + "%"),
      });

      const search_arr = searchPurify.split(" ");
      for (let x in search_arr) {
        if (x != "") {
          queries.push({
            name: "first_name",
            op: "like",
            val: encodeURIComponent("%" + search_arr[x] + "%"),
          });
          queries.push({
            name: "last_name",
            op: "like",
            val: encodeURIComponent("%" + search_arr[x] + "%"),
          });
          queries.push({
            name: "spouse_first_name",
            op: "like",
            val: encodeURIComponent("%" + search_arr[x] + "%"),
          });
          queries.push({
            name: "spouse_last_name",
            op: "like",
            val: encodeURIComponent("%" + search_arr[x] + "%"),
          });
        }
      }
      if (filters !== "") filters = filters + ",";
      filters = filters + '{"or":' + JSON.stringify(queries) + "}";
    }
    // if (callpage.indexOf("saved-for-later") < 0 && callpage !== "bfiles") {

    //     if (filters !== '') filters = filters + ',';
    //     filters = filters + '{"name":"is_saved_for_later","op":"==","val":"0"}';
    // }
    if (callpage == "saved_for_later" && callpage !== "bfiles") {
      if (filters !== "") filters = filters + ",";
      filters = filters + '{"name":"is_saved_for_later","op":"==","val":"1"}';
    }

    if (callpage === "vo-sent-to-financial") {
      // F.log("filters ==>> 1 ", filters);
      if (filters !== "") filters = filters + ",";
      filters =
        filters +
        '{"name":"vo_sent_date","op":">=","val":"%from%"},{"name":"vo_sent_date","op":"<=","val":"%to%"},{"name": "vob_completed","op": "==","val": "1"},{"name":"vob_archived","op":"is_null"}';
    }

    if (callpage === "vo-not-reached" || callpage === "vo-not-interested") {
      // F.log("filters ==>> 1 ", filters);
      if (filters !== "") filters = filters + ",";
      filters =
        filters +
        '{"name":"created_on","op":">=","val":"%from%"},{"name":"created_on","op":"<=","val":"%to%"}';
    }

    if (callpage.indexOf("rs-") >= 0) {
      if (filters !== "") filters = filters + ",";
      filters =
        filters +
        '{"or":[{"and":[{"name":"rs_date","op":">=","val":"%from%"},{"name":"rs_date","op":"<","val":"%to%"}]},{"and":[{"name":"created_on","op":">=","val":"%from%"},{"name":"created_on","op":"<=","val":"%to%"}]}]}';
    }

    // if (
    //   callpage === "virtual-follow-up-due-calls" ||
    //   callpage === "virtual-follow-up-incompleted-calls"
    // ) {
    //   if (filters !== "") filters = filters + ",";

    //   filters =
    //     filters +
    //     '{"or":[{"name":"vo_sent_date","op":">=","val":"%from%"},{"name":"vo_sent_date","op":"<","val":"%to%"}]}';
    // }

    //As per new requirement
    // let is_all_bfiles = this.isAllBFiles();
    let is_all_bfiles = false;

    if (!is_all_bfiles) {
      if (
        callpage !== "onboarding-calls" &&
        callpage !== "financial-intro" &&
        callpage !== "renewal" &&
        callpage !== "renewal-mycalls" &&
        callpage !== "onboarding-calls-attempted"
      ) {
        if (date_range) {
          if (
            callpage !== "rs-upcoming-calls" &&
            callpage !== "sent-to-vonboarder" &&
            callpage.indexOf("vo-") < 0 &&
            callpage.indexOf("pending-") < 0 &&
            callpage !== "renewals" &&
            callpage !== "onboarding-calls-total" &&
            callpage.indexOf("rs-") < 0 &&
            callpage.indexOf("review-scheduler-") < 0 &&
            callpage !== "virtual-follow-up-due-calls" &&
            callpage !== "virtual-follow-up-incompleted-calls" &&
            callpage !== "von-calls-made"
          ) {
            // if (filters !== '') filters = filters + ',';
            // filters = filters + '{"name":"created_on","op":">=","val":"%from%"},{"name":"created_on","op":"<=","val":"%to%"}';
            if (filters !== "" && title !== "Bad Phone Number")
              filters = filters + ",";
            if (title !== "Bad Phone Number") {
              filters =
                filters +
                '{"or":[{"and":[{"name":"vo_sent_date","op":">=","val":"%from%"},{"name":"vo_sent_date","op":"<=","val":"%to%"}]},{"and":[{"name":"created_on","op":">=","val":"%from%"},{"name":"created_on","op":"<=","val":"%to%"}]}]}';
            }
          }
          // new add
          ///////////////////////////////////
          if (
            (callpage === "sent-to-vonboarder" ||
              callpage.indexOf("vo-") >= 0) &&
            callpage !== "vo-sent-to-financial" &&
            callpage !== "vo-not-reached" &&
            callpage !== "vo-not-interested"
          ) {
            // F.log("filters ==>> 2 ", filters);
            if (filters !== "" && title !== "Bad Phone Number")
              filters = filters + ",";
            if (title !== "Bad Phone Number") {
              filters =
                filters +
                '{"name":"vo_sent_date","op":">=","val":"%from%"},{"name":"vo_sent_date","op":"<=","val":"%to%"}';
            }
          }
          ///////////////////////////////////
          if (callpage === "onboarding-calls-total") {
            if (filters !== "") filters = filters + ",";
            filters =
              filters +
              '{"or":[{"and":[{"name":"vo_sent_date","op":">=","val":"%from%"},{"name":"vo_sent_date","op":"<=","val":"%to%"}]},{"and":[{"name":"created_on","op":">=","val":"%from%"},{"name":"created_on","op":"<=","val":"%to%"}]}]}';
          }
          // if (callpage === "rs-upcoming-calls") {
          //   alert(123);
          //   if (filters !== "") filters = filters + ",";
          //   filters =
          //     filters +
          //     '{"or":[{"and":[{"name":"rs_date","op":">=","val":"%from%"},{"name":"rs_date","op":"<","val":"%to%"}]},{"and":[{"name":"created_on","op":">=","val":"%from%"},{"name":"created_on","op":"<=","val":"%to%"}]}]}';
          // }
        }
      }
    }

    if (!is_all_bfiles) {
      if (callpage === "review-scheduler-bfiles") {
        if (filters !== "") filters = filters + ",";
        filters =
          filters +
          '{"name":"rs_appointment_date","op":">=","val":"%from%"},{"name":"rs_appointment_date","op":"<","val":"%to%"}';
      } else if (callpage === "user-rs-appointments-scheduled") {
        if (filters !== "") filters = filters + ",";
        filters =
          filters +
          '{"name":"rs_date","op":">=","val":"%from%"},{"name":"rs_date","op":"<","val":"%to%"}';
      } else if (
        callpage === "review-scheduler-calls-made" ||
        callpage === "von-calls-made"
      ) {
        if (filters !== "") filters = filters + ",";
        filters =
          filters +
          '{"and":[{"name":"created_on","op":">=","val":"%from%"},{"name":"created_on","op":"<=","val":"%to%"}]}';
      } else {
        if (
          callpage.indexOf("rs-") >= 0 ||
          callpage.indexOf("review-scheduler-") >= 0
        ) {
          if (filters !== "") filters = filters + ",";
          filters =
            filters +
            '{"or":[{"and":[{"name":"rs_date","op":">=","val":"%from%"},{"name":"rs_date","op":"<","val":"%to%"}]},{"and":[{"name":"created_on","op":">=","val":"%from%"},{"name":"created_on","op":"<=","val":"%to%"}]}]}';
        }
      }
    }

    if (
      callpage !== "deleted" &&
      callpage !== "archived" &&
      callpage !== "renewals" &&
      callpage !== "review-scheduler-not-interested" &&
      filters.indexOf("archive") < 0 &&
      callpage !== "vo-sent-to-financial" && // new condition added
      callpage !== "vo-not-reached"
    ) {
      if (filters !== "") filters = filters + ",";
      filters = filters + '{"name":"archive","op":"==","val":"0"}';

    }

    if (callpage !== "deleted") {
      if (filters !== "") filters = filters + ",";
      filters = filters + '{"name":"deleted","op":"==","val":"0"}';

    }

    // new add for handling my stats
    if (
      // callpage === "cross-sell-policies-uncovered" &&
      this.props.location.state != null &&
      this.props.location.state.user_t != null &&
      typeof this.props.location.state.user_t != "string"
      // &&
      // this.props.location.state.user_t.trim().length > 0
    ) {
      if (filters !== "") filters = filters + ",";
      // filters = filters + '{"name":"user_id","op":"==","val":"%user_id%"}';
      filters =
        filters +
        '{"name":"user_id","op":"==","val":' +
        `${this.props.location.state.user_t}` +
        "}";
    }

    filters = filters.replace(
      /%reviewer_id%/g,
      new URLSearchParams(this.props.location.search).get("reviewer_id")
    );

    filters = filters.replace(/%user_id%/g, user.id);
    // filters = filters.replace(/%from%/g, start_date);
    // filters = filters.replace(/%to%/g, end_date);
    filters = filters.replace(/%from%/g, `${start_date} 00:00:00`);
    filters = filters.replace(/%to%/g, `${end_date} 23:59:59`);
    filters = filters.replace(/%today%/g, today);

    if (typeof this.props.match.params.ea !== "undefined") {
      if (filters !== "") filters = filters + ",";
      filters =
        filters +
        '{"name":"onboarding_id","op":"==","val":"' +
        this.props.match.params.ea +
        '"}';
    }
    if (typeof this.props.match.params.lsp !== "undefined") {
      if (filters !== "") filters = filters + ",";
      filters =
        filters +
        '{"name":"user_id","op":"==","val":"' +
        this.props.match.params.lsp +
        '"}';
    }
    if (typeof this.props.match.params.efs !== "undefined") {
      if (filters !== "") filters = filters + ",";
      filters =
        filters +
        '{"name":"financial_id","op":"==","val":"' +
        this.props.match.params.efs +
        '"}';
    }

    // new add
    if (title !== "Bad Phone Number") {
      filters = F.getDncFilter(filters);
    }
    this.setState(
      {
        title,
        filters,
        endpoint,
        columns,
        order_by,
        date_range,
        callpage,
        page: 1,
      },
      () => {
        this.loadCalls(1);
      }
    );
  };


  getAllDeletedBfiles = async (url) => {
    this.setState({ loading: true });

    try {
      const res = await axios.get(url);
      const objects = res.data.objects || [];
      const convertedBfiles = F.convertTypeOfCall(objects);

      this.setState({
        bfiles: convertedBfiles,
        total_pages: res.data.total_pages || 0,
      });
    } catch (error) {
      console.error("Error fetching data:", error);
      this.setState({
        bfiles: [],
        total_pages: 0,
      });
    } finally {
      this.setState({ loading: false });
    }
  }


  loadCalls = (page) => {
    const { start_date, end_date, filters, endpoint } = this.state;
    F.log("Filters = > ", filters);
    let { order_by, orderBy, orderBySort } = this.state;
    const historyState = this.props.history.location;
    let user = JSON.parse(Cookies.get("user_info"));
    let url = null;
    if (historyState.pathname == '/bfiles/deleted') {
      let params = {};
      params.user_id = user.id;
      params.agency_id = user.agency_id;
      params.from = '2010-01-01';
      params.to = '2050-01-01';
      params.page = page;
      if (this.state.search) {
        params.search_param = this.state.search;
      }

      let order_by = this.state.orderBySort && this.state.orderBy
        ? { field: this.state.orderBy, direction: this.state.orderBySort }
        : null;

      if (!order_by) {
        this.setState({
          orderBySort: 'desc',
          orderBy: 'updated_on',
        });
        order_by = { field: 'updated_on', direction: 'desc' };
      }

      params.order_by = JSON.stringify([order_by])
      const queryString = new URLSearchParams(params).toString();
      const url = `${GET_ALL_DELETED_BFILES}?${queryString}`;
      this.getAllDeletedBfiles(url);
    } else {
      if (endpoint === OLD_BFILE_API_URL) {
        url =
          "/" +
          endpoint +
          `${(user.user_type === "SUPER_ADMIN" &&
            `?user_type=${historyState.state && historyState.state.user_type}`) ||
          ""}` +
          `${user.user_type === "SUPER_ADMIN" ? "&page=" : "?page="}` +
          page;
      } else {
        url =
          "/api/" +
          endpoint +
          `${(user.user_type === "SUPER_ADMIN" &&
            `?user_type=${historyState.state && historyState.state.user_type}`) ||
          ""}` +
          `${user.user_type === "SUPER_ADMIN" ? "&page=" : "?page="}` +
          page;
      }

      this.setState({ loading: true, bfiles: [] });

      if (orderBy && orderBySort) {
        order_by =
          '{"field":"' + orderBy + '","direction":"' + orderBySort + '"}';
      } else {
        if (!order_by) {
          order_by = '{"field":"updated_on","direction":"desc"}';
        }
        let orderByObj = JSON.parse(order_by);
        this.setState({
          orderBy: orderByObj.field,
          orderBySort: orderByObj.direction,
        });
      }

      if (filters !== "") {
        url =
          url + '&q={"filters":[' + filters + '],"order_by":[' + order_by + "]}";
      }

      axios.get(url).then((res) => {
        if (page == this.state.page) {
          let bfiles = [];
          let total_pages = 0;
          // let page = 1;

          if (typeof res.data.objects !== "undefined") {
            F.log("Res data = > ", res.data);
            bfiles = res.data.objects;
            // page = res.data.page;
            total_pages = res.data.total_pages;
          }

          if (typeof res.data.results !== "undefined") {
            bfiles = res.data.results;
          }

          bfiles = F.convertTypeOfCall(bfiles)

          // for (let i = 0; i < bfiles.length; i++) {
          //   bfiles[i].checked = false;
          // }

          // -------------- new code for handling pagination - START --------------

          const selectedRowKeysClone = [];

          if (
            this.state.selectedPageAndBFileIDs[page] &&
            this.state.selectedPageAndBFileIDs[page].length > 0
          ) {
            const selectedIDs = this.state.selectedPageAndBFileIDs[page]; // [100,122]
            for (let i = 0; i < selectedIDs.length; i++) {
              // let bfile = bfiles[i];
              for (let j = 0; j < bfiles.length; j++) {
                if (bfiles[j].id == selectedIDs[i]) {
                  selectedRowKeysClone.push(j);
                }
              }
            }
          }

          // --------------  new code for handling pagination - END --------------

          this.setState({
            loading: false,
            bfiles,
            // page,
            total_pages,
            selectedRowKeys: selectedRowKeysClone,
          });
        }
      });
    }
  };
  onSelectChange = (selectedRowKeys) => {
    const { bfiles, page, selectedPageAndBFileIDs } = this.state;

    // Add selected bfile rows to state
    const selectedBFilesIDs = [];
    for (let i = 0; i < selectedRowKeys.length; i++) {
      const selectedRowIndex = selectedRowKeys[i];
      selectedBFilesIDs.push(bfiles[selectedRowIndex].id); // add bfiles id
    }

    // clone selected Page And BFile IDs as unique referrence
    const selectedPageAndBFileIDsClone = cloneDeep(selectedPageAndBFileIDs);
    if (selectedBFilesIDs.length <= 0) {
      delete selectedPageAndBFileIDsClone[page];
    } else {
      selectedPageAndBFileIDsClone[page] = selectedBFilesIDs;
    }

    this.setState({
      selectedRowKeys,
      selectedPageAndBFileIDs: selectedPageAndBFileIDsClone,
    });
  };
  onChangeDateRange = (date, dateString) => {
    let start_date = null;
    let end_date = null;
    let period = null;

    // Check If User pressed on `crossed` icon `Reset to Monthly View`
    if (dateString[0].length === 0 && dateString[1].length === 0) {
      start_date = moment(new Date("2010-01-01")).format(API_DATE_FORMAT);
      end_date = moment(new Date("2050-01-01")).format(API_DATE_FORMAT);
      period = "all_bfiles";
    } else {
      start_date = dateString[0];
      end_date = dateString[1];
      period = "from_to";
    }

    this.setState(
      {
        start_date: start_date,
        end_date: end_date,
        period: period,
        selectedRowKeys: [],
        selectedPageAndBFileIDs: {},
      },
      () => {
        this.updateFilters();
      }
    );
  };

  setGlobalDates = (start_date, end_date) => {
    const myDateObj = localStorage.getItem("dateObj");

    if (myDateObj != null && myDateObj) {
      const parsedDateObj = JSON.parse(myDateObj);
      // Create Moment objects from parsed dates and format them as MM.DD.YYYY
      const startDate = parsedDateObj.start_date ? moment(parsedDateObj.start_date).format(API_DATE_FORMAT) : null;
      const endDate = parsedDateObj.end_date ? moment(parsedDateObj.end_date).format(API_DATE_FORMAT) : null;

      // Set the dates only if valid, otherwise set to null
      this.setState(
        {
          start_date: startDate,
          end_date: endDate,
          period: moment(parsedDateObj.start_date).isSame("2010-01-01", "day") && moment(parsedDateObj.end_date).isSame("2050-01-01", "day") ? "all_bfiles" : "from_to",
          selectedRowKeys: [],
          selectedPageAndBFileIDs: {},
        },
        () => {
          this.updateFilters();
        }
      );
    }
    else {
      this.setState(
        {
          start_date: moment("2010-01-01").format(API_DATE_FORMAT),
          end_date: moment("2050-01-01").format(API_DATE_FORMAT),
          period: "all_bfiles",
          selectedRowKeys: [],
          selectedPageAndBFileIDs: {},
        },
        () => {
          this.updateFilters();
        });
    }
  }
  all = () => {
    const start_date = moment(new Date("2010-01-01")).format(API_DATE_FORMAT);
    const end_date = moment(new Date("2050-01-01")).format(API_DATE_FORMAT);
    window.localStorage.user_start_date = start_date;
    window.localStorage.user_end_date = end_date;
    window.localStorage.user_period = "all_bfiles";

    this.setState(
      {
        start_date: start_date,
        end_date: end_date,
        period: "all_bfiles",
        selectedRowKeys: [],
        selectedPageAndBFileIDs: {},
      },
      () => {
        this.updateFilters();
      }
    );
  };
  delete = (bfile_id) => {
    this.setState({ loading: true });
    axios
      .put("/api/b_file/" + bfile_id, {
        deleted: 1,
      })
      .then((res) => {
        /*axios.post("/api/bfile_notes", {
                "bfile_id": bfile_id,
                "note": "Customer B File has been deleted.",
                "user_id": user.id
            });*/

        this.setState({ loading: false }, () => {
          this.loadCalls(1);
        });
      });
  };

  archive = (bfile_id) => {
    this.setState({ loading: true });
    axios
      .put("/api/b_file/" + bfile_id, {
        archive: 1,
      })
      .then((res) => {
        this.setState({ loading: false }, () => {
          this.loadCalls(1);
        });
      });
  };

  reactivate = (bfile_id) => {
    this.setState({ loading: true });
    axios
      .put("/api/b_file/" + bfile_id, {
        deleted: 0,
      })
      .then((res) => {
        this.setState({ loading: false }, () => {
          this.loadCalls(1);
        });
      });
  };

  delete_bfile = () => {
    const { selectedRowKeys, bfiles } = this.state;
    const promises = [];
    const selectedBfiles = [];
    for (var i = 0; i < selectedRowKeys.length; i++) {
      selectedBfiles.push(bfiles[selectedRowKeys[i]]);
    }
    this.setState({ loading: true });
    for (let i = 0; i < selectedBfiles.length; i++) {
      let bfile = selectedBfiles[i].id;
      let promise = new Promise(function (resolve, reject) {
        axios
          .put("/api/b_file/" + bfile, {
            deleted: 1,
          })
          .then((res) => {
            resolve();
          })
          .catch((res) => {
            reject();
          });
      });
      promises.push(promise);
    }
    Promise.all(promises).then((val) => {
      this.setState(
        { loading: false, selectedBfiles: [], selectedRowKeys: [] },
        () => {
          this.loadCalls(1);
        }
      );
    });
  };
  // TODO: Not in use anywhere in code and UI
  archive_bfile = () => {
    const { selectedRowKeys, bfiles } = this.state;
    const promises = [];
    const selectedBfiles = [];
    for (var i = 0; i < selectedRowKeys.length; i++) {
      selectedBfiles.push(bfiles[selectedRowKeys[i]]);
    }
    this.setState({ loading: true });
    for (let i = 0; i < selectedBfiles.length; i++) {
      let bfile = selectedBfiles[i].id;
      let promise = new Promise(function (resolve, reject) {
        axios
          .put("/api/b_file/" + bfile, {
            archive: 1,
          })
          .then((res) => {
            resolve();
          })
          .catch((res) => {
            reject();
          });
      });
      promises.push(promise);
    }
    Promise.all(promises).then((val) => {
      this.setState(
        { loading: false, selectedBfiles: [], selectedRowKeys: [] },
        () => {
          this.loadCalls(1);
        }
      );
    });
  };

  transfer_bfile = () => {
    const { selectedRowKeys, bfiles } = this.state;
    const selectedBfiles = [];
    for (var i = 0; i < selectedRowKeys.length; i++) {
      selectedBfiles.push(bfiles[selectedRowKeys[i]]);
    }
    this.setState({ selectedBfiles, transfer_bfile_modal: true });
  };
  // TODO: not found where to use this in UI as agency owner and staff
  change_creator = () => {
    const { selectedRowKeys, bfiles } = this.state;
    const selectedBfiles = [];
    for (var i = 0; i < selectedRowKeys.length; i++) {
      selectedBfiles.push(bfiles[selectedRowKeys[i]]);
    }
    this.setState({ selectedBfiles, change_creator_modal: true });
  };

  reschedule = () => {
    const { selectedPageAndBFileIDs } = this.state;

    const selectedBFileIDs = F.getSelectedBFileIDsWithParticularPage(
      selectedPageAndBFileIDs
    );

    // show loader
    this.setState({ loading: true });

    // cal API for rescheduling selected B Files IDs
    axios
      .post("/api/reschedule_appointments_for_not_reached", {
        bfile_ids: selectedBFileIDs,
        agency_id: this.state.agency,
      })
      .then((res) => {
        this.setState(
          { loading: false, selectedRowKeys: [], selectedPageAndBFileIDs: {} },
          () => {
            // reload current "Not Reached" B Files list
            this.loadCalls(1);
          }
        );
      })
      .catch((error) => {
        this.setState({ loading: false }, () =>
          F.showAndHandleServerError(error)
        );
      });
  };

  parseIntAdv = (str) => {
    if (str && str !== "") {
      return parseInt(str);
    }
    return 0;
  };
  sendNotification = (bfile) => {
    F.log("BFILE =>", bfile);
    // let { email, agency: { primary_ea_id } } = bfile

    // let data = {
    //     notification_message: `The phone number of the customer (${email}) is not valid, Kindly change it`,
    //     user_ids: [primary_ea_id],
    //     severity: "low",
    //     dispatch_time: Math.floor(Date.now() / 1000)
    // }

    axios
      .post("/api/get_all_user_for_bad_phone_number_notification", {
        agency_id: bfile.agency_id,
      })
      .then((res) => {
        F.log("Res.data = > ", res.data.data);
        if (res.data.data.length) {
          let data = {
            notification_message: `The phone number for ${bfile.first_name}, ${bfile.last_name} is not valid. Please update it.`,
            user_ids: res.data.data,
            severity: "low",
            dispatch_time: Math.floor(Date.now() / 1000),
            bfile_id: bfile.id,
          };
          axios.post("/api/create_notification", data).then((res) => {
            F.log("res.data = > ", res.data);
            message.success(F.translate(`Notification Sent Successfully`));
          });
        } else {
          message.info(F.translate(`No Users to Notify`));
        }

        // this.setState({
        //     bad_phone : res.data.data
        // })
      });
  };

  searchUser = (event) => {
    this.setState({ search: event.target.value }, () => {
      debounceQuery(this.updateFilters.bind(this));
    });
  };

  refreshInfo = () => {

    localStorage.removeItem("agGridColumnState");

    if (this.state.columnApi) {
      this.state.columnApi.resetColumnState();
      this.state.columnApi.resetColumnGroupState();
    }


    this.setState(
      {
        search: "",
        filters: "",
        period: "mtd",
        start_date: moment(
          new Date(today.getFullYear(), today.getMonth(), 1)
        ).format(API_DATE_FORMAT),
        end_date: moment(
          new Date(new Date(today.getFullYear(), today.getMonth() + 1, 1))
        ).format(API_DATE_FORMAT),
        columns: null,
        order_by: "updated_on",
        date_range: true,
        orderBy: "",
        orderBySort: null,
        agency: "",
      },
      () => {
        this.call_rs_agencies();
        this.call_vo_agancies();
        this.updateFilters();
      }
    );
  };



  onGridReady = (params) => {
    this.setState({
      gridApi: params.api,
      columnApi: params.columnApi
    });

    const savedState = localStorage.getItem("agGridColumnState");
    if (savedState) {
      params.columnApi.applyColumnState({
        state: JSON.parse(savedState),
        applyOrder: true,
      });
    }
  }

  saveState = (params) => {
    const state = params.columnApi.getColumnState();
    localStorage.setItem("agGridColumnState", JSON.stringify(state));
  }



  render() {
    const {
      title,
      start_date,
      end_date,
      bfiles,
      user,
      loading,
      selectedRowKeys,
      windowHeight,
      page,
      total_pages,
      date_range,
      agencies,
      callpage,
    } = this.state;

    // const dateFormat = "YYYY-MM-DD";

    const rowSelection = {
      selectedRowKeys,
      onChange: this.onSelectChange,
    };

    const menu = <Menu />;

    let columns = [
      {
        title: (
          <div>
            <Translate text={`Name`} /> <br /> <Translate text={`Phone`} />
          </div>
        ),
        dataIndex: "name",
        key: "name",
        width: 200,
      },
      {
        title: (
          <div>
            <Translate text={`Ages`} /> <br /> <Translate text={`Employment`} />
          </div>
        ),
        dataIndex: "ages",
        key: "ages",
        width: 200,
      },
      {
        title: <Translate text={`type_of_call`} />,
        dataIndex: "type_of_call",
        key: "type_of_call",
        width: 200,
      },
      {
        title: (
          <div>
            <Translate text={`sub_type_of_call`} /> <br />{" "}
            <Translate text={`Due Date`} /> <br /> #{" "}
            <Translate text={`Call Attempts`} />
          </div>
        ),
        dataIndex: "status",
        key: "status",
        width: 200,
      },
      // {
      //   title: <Translate text={`Products Sold`} />,
      //   dataIndex: "products_sold",
      //   key: "products_sold",
      //   width: 200,
      // },
      {
        title: (
          <div>
            <Translate text={`Who Created`} /> <br />{" "}
            <Translate text={`Last Updated`} /> <br />{" "}
            <Translate text={`Who Referred`} />
          </div>
        ),
        dataIndex: "who_created",
        key: "who_created",
        width: 200,
      },
      {
        title: <Translate text={`Life Stage`} />,
        dataIndex: "life_stage",
        key: "life_stage",
        width: 200,
      },
      {
        title: <Translate text={`Retirement Dollars`} />,
        dataIndex: "retirement_dollars",
        key: "retirement_dollars",
        width: 200,
      },
      {
        title: <Translate text={`P&C Items In The Household`} />,
        dataIndex: "pc_cross_sell_opp",
        key: "pc_cross_sell_opp",
        width: 200,
      },
      {
        title: <Translate text={`Priority Status`} />,
        dataIndex: "priority_status",
        key: "priority_status",
        width: 200,
      },
      {
        title: <Translate text={`Status`} />,
        dataIndex: "type_of_call",
        key: "type_of_call",
        width: 200,
      },
    ];

    if (this.state.columns) {
      columns = this.state.columns;
    }

    // new add
    // F.testCal(bfiles, callpage);

    const data = [];
    for (let i = 0; i < bfiles.length; i++) {
      let bfile = bfiles[i];
      let ages = [];
      if (bfile.birthday !== "" && bfile.birthday !== null) {
        ages.push(F.getAge(F.validDate(bfile.birthday, "/")));
      }
      if (bfile.spouse_birthday !== "" && bfile.spouse_birthday !== null) {
        ages.push(F.getAge(F.validDate(bfile.spouse_birthday, "/")));
      }
      bfile.age_age = ages.length > 0 ? ages.join("/") : "-";

      let creator_name = "";
      if (bfile && bfile.user) {
        creator_name = bfile.user.first_name + ". " + bfile.user.last_name;
      }

      bfile.priority = "Standard";
      if (bfile.need_attention == 1) {
        bfile.priority = "Urgent";
      }
      if (bfile.sp_500 == 1) {
        bfile.priority = "S&P";
      }
      if (bfile.vip == 1) {
        bfile.priority = "VIP";
      }

      const employment_status = F.bfile_employment_status(bfile);
      const status = F.bfile_status(bfile);
      const life_stage = F.bfile_life_stage(bfile).title;
      data.push({
        key: i,
        date: moment(bfile.created_on).format("MM/DD/YYYY hh:mmA"),
        expiration_date: moment(bfile.expiration_date).format(
          "MM/DD/YYYY hh:mmA"
        ),
        rs_scheduled_date: bfile.rs_scheduled_date
          ? moment(bfile.rs_scheduled_date).format("MM/DD/YYYY hh:mmA")
          : "-",
        rs_appointment_date: bfile.rs_appointment_date
          ? moment(bfile.rs_appointment_date).format("MM/DD/YYYY hh:mmA")
          : "-",
        first_name: (
          <Link to={"/customer/" + bfile.id}>{bfile.first_name}</Link>
        ),
        last_name: <Link to={"/customer/" + bfile.id}>{bfile.last_name}</Link>,
        customer_name: (
          <Link to={"/customer/" + bfile.id}>
            {bfile.first_name} {bfile.last_name}
          </Link>
        ),
        name: (
          <div>
            <div>
              <ActionMenu
                bfile={bfile}
                user={user}
                history={this.props.history}
                update={(bfile) => this.loadCalls(page)}
                refresh={() => this.loadCalls(page)}
                is_callpage={true}
              />
            </div>

            <div className="phoneField">
              <Icon type="phone" style={{ marginRight: 10 }} />
              <a href={"tel:" + F.phone_format(bfile.phone)}>
                {F.phone_format(bfile.phone)}
              </a>{" "}
            </div>
            {bfile.phone2 && bfile.phone2 !== "" ? (
              <div className="phoneField">
                <Icon type="phone" style={{ marginRight: 10 }} />
                <a href={"tel:" + F.phone_format(bfile.phone2)}>
                  {F.phone_format(bfile.phone2)}
                </a>
              </div>
            ) : null}
          </div>
        ),
        agency_name: bfile && bfile.agency && bfile.agency.name,
        phone: (
          <a href={"tel:" + F.phone_format(bfile.phone)}>
            {F.phone_format(bfile.phone)}
          </a>
        ),
        email: bfile.email,
        lsp: bfile.user ? bfile.user.first_name + " " + bfile.user.last_name : "",
        appointment_date: moment(bfile.rs_appointment_date).format(
          "MM/DD/YYYY hh:mm a"
        ),
        ages: (
          <div>
            {bfile.age_age} <br />{" "}
            <Translate text={employment_status ? employment_status : ""} />
          </div>
        ),
        type_of_call: F.getTypeOfCall(bfile, "-"),
        status: (
          <div>
            <div style={{ width: 150 }}>
              <Tooltip
                title={get_label_from_value(
                  F.getSubTypeOfCall(bfile, "-"),
                  "label",
                  F.getTypeOfCall(bfile, "-")
                )}
              >
                <div
                  style={{
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                  }}
                >
                  {get_label_from_value(
                    F.getSubTypeOfCall(bfile, "-"),
                    "label",
                    F.getTypeOfCall(bfile, "-")
                  )}
                </div>
              </Tooltip>
            </div>
            {F.bfile_due_date(bfile, user.default_date)}
            <br />
            <span>
              {this.parseIntAdv(F.getCallAttemptsFromBFileQuestionArray(bfile)) +
                this.parseIntAdv(bfile.attempts) +
                this.parseIntAdv(bfile.rs_attempts) || 0}
            </span>
            {/* {bfile.rs_attempts ? (
              <span>
                {this.parseIntAdv(
                  F.getCallAttemptsFromBFileQuestionArray(bfile)
                )}
                this.parseIntAdv(bfile.attempts) +
                  this.parseIntAdv(bfile.rs_attempts) || 0
              </span>
            ) : (
              <span>
                {this.parseIntAdv(
                  F.getCallAttemptsFromBFileQuestionArray(bfile)
                )}
                + this.parseIntAdv(bfile.attempts) || 0
              </span>
            )} */}
          </div>
        ),
        // products_sold: (
        //   <div>
        //     {F.bfile_items_sold(bfile).map((item, i) => (
        //       <span key={i}>
        //         {i > 0 ? ", " : null}
        //         <Translate text={item ? item : ""} />
        //       </span>
        //     ))}
        //     {F.log()}
        //   </div>
        // ),

        who_created: (
          <div>
            {creator_name} <br />{" "}
            {moment(bfile.updated_on).format("MM/DD/YYYY hh:mmA")} <br />{" "}
            {bfile.referred_by || "-"}
          </div>
        ),
        life_stage: <Translate text={life_stage ? life_stage : ""} />,
        retirement_dollars: F.dollar_format(
          F.bfile_get_retirement_dollars(bfile)
        ),

        pc_cross_sell_opp: bfile.cross_sell_policies_uncovered,
        // (bfile.primary_vehicles_num - 1) +
        // (bfile.primary_vehicles_toggle === "1" ||
        // bfile.primary_vehicles_toggle === "2"
        //   ? 1
        //   : 0) +
        // (bfile.home_toggle === "1" || bfile.home_toggle === "2" ? 1 : 0),
        // bfile.secondary_vehicles_toggle_num
        //   ? bfile.secondary_vehicles_num
        //   : this.state.secondary_vehicles_num,
        // bfile.secondary_vehicles_toggle_num,
        // (bfile.primary_vehicles_toggle === "1"
        //   ? bfile.primary_vehicles_num
        //   : (bfile.primary_vehicles_num = 0)) +
        // (bfile.secondary_vehicles_toggle === "1"
        //   ? bfile.secondary_vehicles_num
        //   : (bfile.secondary_vehicles_num = 0)) +
        // (bfile.home_toggle === "1" || bfile.home_toggle === "2" ? 1 : 0) +
        // (bfile.primary_vehicles_toggle === "1" ? 1 : 0),
        priority_status: (
          <Translate text={bfile.priority ? bfile.priority : ""} />
        ),
        view: (
          <Link to={"/customer/" + bfile.id}>
            <Button type="primary">
              <Translate text={`View`} />
            </Button>
          </Link>
        ),
        upcoming_calls_actions: (
          <div>
            <Link to={"/customer/" + bfile.id}>
              <Button type="primary">
                <Translate text={`View`} />
              </Button>
            </Link>
            <Popconfirm
              placement="topRight"
              title={"Do you really want to delete this B File?"}
              onConfirm={() => this.delete(bfile.id)}
              okText="Yes"
              cancelText="No"
            >
              <Button style={{ marginLeft: 10 }}>
                <Translate text={`Delete`} />
              </Button>
            </Popconfirm>
            <Button
              style={{ marginLeft: 10 }}
              onClick={() =>
                this.setState({
                  setup_appointment_modal: true,
                  bfile,
                })
              }
            >
              <Translate text={`Setup Appointment`} />
            </Button>
            <Button
              style={{ marginLeft: 10 }}
              onClick={() => this.sendNotification(bfile)}
            >
              <Translate text={`Request New Number`} />
            </Button>
          </div>
        ),
        reactivate_action: (
          <div>
            <Button onClick={() => this.reactivate(bfile.id)}
              className="borderRadius-28"
            >
              <Translate text={`Re-activate`} />
            </Button>
          </div>
        ),
      });
    }

    F.log(
      "selectedPageAndBFileIDs ==>> " +
      JSON.stringify(this.state.selectedPageAndBFileIDs)
    );

    // Convert AntD columns to AgGrid columnDefs with CustomHeader
    const columnDefs = columns.map(col => {

      if (col.dataIndex === 'reactivate_action' || col.key === 'reactivate_action') {
        return {
          ...col,
          headerName: 'Actions',
          field: col.dataIndex,
          width: col.width,
          cellRendererFramework: params => params.value,
          headerComponent: CustomHeader,
          headerComponentParams: {
            headers: ['Actions'],
          },
        };
      }
      return {
        headerName: typeof col.title === 'string' ? col.title : undefined,
        field: col.dataIndex,
        width: col.width,
        cellRendererFramework: params => params.value,
        headerComponent: CustomHeader,
        headerComponentParams: {
          headers: [typeof col.title === 'string' ? col.title : undefined],
        },
      };
    });

    return (
      <div>
        <Card
          type="inner"
          title={
            <div style={{ paddingTop: 7 }}>
              <Icon
                type="folder"
                style={{ marginRight: 10, color: "#1890ff" }}
              />
              <Translate text={title} />
            </div>
          }
          className="tableCard p_and_c_card"
          loading={loading}
          extra={
            <div
              style={{
                display: "flex",
                justifyContent: "end",
                flexDirection: window.innerWidth < 768 ? "column" : "row", // Column on mobile, row on desktop
                gap: "16px", // Add spacing between elements
                width: "100%",
              }}
              id="row-bfile-list"
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "16px", // Add spacing between elements
                  width: window.innerWidth < 768 ? "100%" : "70%", // Full width on mobile, 70% on desktop
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: window.innerWidth < 768 ? "column" : "row", // Column on mobile, row on desktop
                    gap: "16px", // Add spacing between elements
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      gap: "10px", // Add spacing between elements
                      alignItems: "center",
                      width: window.innerWidth < 768 ? "100%" : "auto", // Full width on mobile, auto on desktop
                    }}
                  >
                    <div>
                      <Icon
                        type="swap"
                        style={{
                          marginTop: 10,
                          marginRight: 10,
                          color: "#1890ff",
                        }}
                      />
                    </div>
                    <Select
                      className="custom-select"
                      value={this.state.orderBy}
                      style={{ minWidth: "45%" }}
                      onChange={(val) => {
                        this.setState(
                          {
                            orderBy: val,
                            selectedRowKeys: [],
                            selectedPageAndBFileIDs: {},
                          },
                          () => {
                            this.updateFilters();
                          }
                        );
                      }}
                    >
                      <Option value={"id"}>{"Order by..."}</Option>
                      <Option value={"created_on"}>{"Date"}</Option>
                      <Option value={"first_name"}>{"Customer Name"}</Option>
                      <Option value={"expiration_date"}>{"Schedule by Date"}</Option>
                      <Option value={"rs_scheduled_date"}>{"Scheduled Date"}</Option>
                    </Select>

                    <Select
                      className="custom-select"
                      value={this.state.orderBySort}
                      style={{ minWidth: "30%", marginLeft: 10 }}
                      onChange={(val) => {
                        this.setState(
                          {
                            orderBySort: val,
                            selectedRowKeys: [],
                            selectedPageAndBFileIDs: {},
                          },
                          () => {
                            this.updateFilters();
                          }
                        );
                      }}
                    >
                      <Option value={"asc"}>{"Asc."}</Option>
                      <Option value={"desc"}>{"Desc."}</Option>
                    </Select>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      gap: "10px", // Add spacing between elements
                      width: window.innerWidth < 768 ? "100%" : "auto", // Full width on mobile, auto on desktop
                    }}
                  >
                    <Translator>
                      {({ translate }) => (
                        <Input
                          className="custom-rounded-input"
                          suffix={<Icon type="search" />}
                          placeholder={translate({ text: `Search` }) + ""}
                          style={{ width: "100%" }}
                          value={this.state.search}
                          onChange={(e) => this.searchUser(e)}
                          onPressEnter={() => {
                            this.updateFilters();
                          }}
                        />
                      )}
                    </Translator>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      gap: "10px", // Add spacing between elements
                      width: window.innerWidth < 768 ? "100%" : "auto", // Full width on mobile, auto on desktop
                    }}
                  >
                    <Button
                      icon="reload"
                      type="primary"
                      className="bg-164897 borderRadius-28"
                      onClick={this.refreshInfo}
                    >
                      {" "}
                      <Translate text={`Refresh`} />
                    </Button>
                  </div>
                  {user.user_type === "EFS" ||
                    user.user_type === "REVIEWSCHEDULER" ||
                    user.user_type === "VONBOARDER" ? (
                    <div
                      style={{
                        display: "flex",
                        gap: "10px", // Add spacing between elements
                        width: window.innerWidth < 768 ? "100%" : "auto", // Full width on mobile, auto on desktop
                      }}
                    >
                      <Select
                        className="custom-rounded-input"
                        value={this.state.agency}
                        style={{ width: "100%" }}
                        onChange={(val) => {
                          this.setState(
                            {
                              agency: val,
                              selectedRowKeys: [],
                              selectedPageAndBFileIDs: {},
                            },
                            () => {
                              if (
                                user.user_type === "REVIEWSCHEDULER" ||
                                user.user_type === "VONBOARDER"
                              ) {
                                window.localStorage.rs_agency_id = val;
                              } else {
                                window.localStorage.efs_agency_id = val;
                              }
                              this.updateFilters();
                            }
                          );
                        }}
                      >
                        <Option value={""}>{"Filter by Agency"}</Option>
                        {agencies.map((agency, i) => (
                          <Option key={i} value={agency.id}>
                            {agency.name}
                          </Option>
                        ))}
                      </Select>
                    </div>
                  ) : null}
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "16px", // Add spacing between elements
                  // width: window.innerWidth < 768 ? "100%" : "30%", // Full width on mobile, 30% on desktop
                  justifyContent: "flex-end"
                }}
              >
                {this.state.date_range ? (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: window.innerWidth < 768 ? "column" : "row", // Column on mobile, row on desktop
                      gap: "16px", // Add spacing between elements
                      width: "100%",
                      justifyContent: "flex-end"
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        gap: "10px", // Add spacing between elements
                        width: window.innerWidth < 768 ? "100%" : "auto", // Full width on mobile, auto on desktop
                      }}
                    >
                      {this.state.period != null &&
                        this.state.period === "all_bfiles" ? (
                        <Button
                          style={{ width: "100%" }}
                          type="primary"
                          onClick={this.all.bind(this)}
                        >
                          <Translate text={`All`} />
                        </Button>
                      ) : (
                        <Button
                          style={{ width: "100%" }}
                          onClick={this.all.bind(this)}
                        >
                          <Translate text={`All`} />
                        </Button>
                      )}
                    </div>
                    <div
                      style={{
                        display: "flex",
                        gap: "10px", // Add spacing between elements
                        width: window.innerWidth < 768 ? "100%" : "auto", // Full width on mobile, auto on desktop
                      }}
                    >
                      {this.state.period != null &&
                        this.state.period === "all_bfiles" ? (
                        <RangePicker
                          style={{ width: "100%" }}
                          value={[
                            moment(new Date("2010-01-01")),
                            moment(new Date("2050-01-01")),
                          ]}
                          onChange={this.onChangeDateRange}
                          format={API_DATE_FORMAT}
                        />
                      ) : (
                        <RangePicker
                          style={{ width: "100%" }}
                          value={[
                            moment(new Date(start_date)),
                            moment(new Date(end_date)),
                          ]}
                          onChange={this.onChangeDateRange}
                          format={API_DATE_FORMAT}
                        />
                      )}
                    </div>
                    {this.state.show_history_button === true ? (
                      <div
                        style={{
                          display: "flex",
                          gap: "10px", // Add spacing between elements
                          width: window.innerWidth < 768 ? "100%" : "auto", // Full width on mobile, auto on desktop
                        }}
                      >
                        <Button
                          style={{ backgroundColor: "#164897", color: "#fff", width: "100%" }}
                          onClick={() => {
                            if (this.isAllBFiles() || this.getGlobalDates()) {
                              this.props.history.push({
                                pathname: "/bfiles-history",
                                search: this.props.location.search,
                              });
                            } else {
                              const params = new URLSearchParams(this.props.location.search);
                              params.set("monthly", true); // Add or update a query parameter

                              this.props.history.push({
                                pathname: "/bfiles-history",
                                search: params.toString(), // Convert back to query string
                              });
                            }
                          }}
                        >
                          <Translate text={`B File History`} />
                        </Button>
                      </div>
                    ) : null}
                  </div>
                ) : null}
              </div>
            </div>
          }
        >
          {(this.state.selectedRowKeys.length > 0 &&
            (user.user_type === "EA" || user.user_type === "LSP")) ||
            (!isEmpty(this.state.selectedPageAndBFileIDs) &&
              (user.user_type === "EA" || user.user_type === "LSP")) ? (
            <div className="toolbarButtons">
              {this.state.selectedRowKeys.length > 0 &&
                (user.user_type === "EA" || user.user_type === "LSP") ? (
                <span>
                  <Button type="default" onClick={this.delete_bfile.bind(this)}>
                    <Translate text={`Delete B File`} />
                  </Button>
                  {user.user_type === "REVIEWADMIN" || (user.user_type === "EA" && user.id === 2) ? (<Button
                    type="default"
                    onClick={this.transfer_bfile.bind(this)}
                  >
                    <Translate text={`Transfer B File `} />
                  </Button>) : null}
                  <Button
                    type="default"
                    onClick={this.change_creator.bind(this)}
                  >
                    <Translate text={`Change Creator`} />
                  </Button>
                </span>
              ) : null}

              {callpage === "review-scheduler-not-reached" &&
                !isEmpty(this.state.selectedPageAndBFileIDs) &&
                (user.user_type === "EA" || user.user_type === "LSP") ? (
                <Button type="default" onClick={this.reschedule}>
                  <Translate text={`Send to Review Scheduler`} />
                </Button>
              ) : null}
            </div>
          ) : null}
          {this.state.selectedRowKeys.length > 0 &&
            (user.user_type === "REVIEWSCHEDULER" ||
              user.user_type === "VONBOARDER") ? (
            <div className="toolbarButtons">
              <Button type="default" onClick={this.archive_bfile.bind(this)}>
                <Translate text={`Archive B File`} />
              </Button>
            </div>
          ) : null}

          {callpage === "deleted" || this.state.user.user_type == AGENCY_MANAGER ? (
            <CustomAgGridTable
              onGridReady={this.onGridReady}
              onColumnMoved={this.saveState}
              onSortChanged={this.saveState}
              onFilterChanged={this.saveState}
              rowDatas={data}
              columnDefss={columnDefs}
              styles={{ height: windowHeight, width: '100%' }}
            />
          ) : (
            <CustomAgGridTable
              rowDatas={data}
              columnDefss={columnDefs}
            // styles={{ height: windowHeight, width: '100%' }}
            />
          )}

          <Pagination
            // className='pagination-container'
            current_page={page}
            total_pages={total_pages}
            onClick={(page) => {
              this.setState(
                {
                  page,
                  selectedRowKeys: [],
                  bfiles: [],
                },
                () => this.loadCalls(page)
              );
              // this.loadCalls(page);
            }}
          />
        </Card>
        {this.state.setup_appointment_modal ? (
          <SetupAppointment
            history={this.props.history}
            showModal={this.state.setup_appointment_modal}
            hideModal={() => this.setState({ setup_appointment_modal: false })}
            bfile={this.state.bfile}
            user={user}
            {...this.props}
          />
        ) : null}
        {this.state.transfer_bfile_modal ? (
          <TransferBfile
            history={this.props.history}
            showModal={this.state.transfer_bfile_modal}
            hideModal={() => this.setState({ transfer_bfile_modal: false })}
            bfiles={this.state.selectedBfiles}
            user={user}
            done={() => {
              this.setState(
                {
                  transfer_bfile_modal: false,
                  selectedBfiles: [],
                  selectedRowKeys: [],
                },
                () => {
                  this.loadCalls(1);
                }
              );
            }}
            {...this.props}
          />
        ) : null}
        {this.state.change_creator_modal ? (
          <ChangeCreator
            history={this.props.history}
            showModal={this.state.change_creator_modal}
            hideModal={() => this.setState({ change_creator_modal: false })}
            bfiles={this.state.selectedBfiles}
            user={user}
            done={() => {
              this.setState(
                {
                  change_creator_modal: false,
                  selectedBfiles: [],
                  selectedRowKeys: [],
                },
                () => {
                  this.loadCalls(1);
                }
              );
            }}
            {...this.props}
          />
        ) : null}
      </div>
    );
  }

  // render() {
  //   return <div>COOLCOOLCOOLCOOLCOOLCOOLCOOLCOOLCOOLCOOLCOOLCOOL</div>;
  // }
}

export default CallPage;



// WEBPACK FOOTER //
// ./src/scenes/CallPage/index.js